import React, { FC, useCallback, memo, useMemo } from 'react';
import _map from 'lodash/map';
import _sortBy from 'lodash/sortBy';
import { useLazyQuery } from '@apollo/client';
import FormikSelectableSearchDropdown from '@minecraft.formik-selectable-search-dropdown';
import ErrorMessage from '@minecraft.error-message';
import { QUERY_SESSIONS } from '../../FilterBasic/FilterBasicCollection/FilterBasicCollectionGraphQL';
import { FilterData } from '../../shared/types';
import { generateSelectOptionsBasedOnField } from '../../shared/utils';
import { Label, StyledFormikSelectableSearchDropdown } from '../../shared/styles';

type Props = {
  name: FilterData['name'];
  projectId: number;
  label: FilterData['label'];
};

const Sessions: FC<Props> = ({ name, projectId, label }) => {
  const [getSessions, { data, loading, error }] = useLazyQuery(QUERY_SESSIONS, {
    variables: {
      projectId,
    },
  });

  const handleSessionsFetch = useCallback((): void => {
    if (!data) {
      getSessions();
    }
  }, [data]);

  const sessionsOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(_sortBy(data?.auditionSessionsByProject?.sessions, 'sortOrder'), 'name');
  }, [data?.auditionSessionsByProject?.sessions]);

  if (error) return <ErrorMessage error={error} />;

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelectableSearchDropdown
        saveAsOption
        name={name}
        isLoading={loading}
        onOptionsFetch={handleSessionsFetch}
      >
        {_map(sessionsOptions, (session) => (
          <FormikSelectableSearchDropdown.Option key={session.value} label={session.label} value={session.value} />
        ))}
      </StyledFormikSelectableSearchDropdown>
    </>
  );
};

export default memo(Sessions);
